export const checkJson = (str) => {
  try {
    const json = JSON.parse(str.split("\n")[1]);

    return typeof json === "object";
  } catch (e) {
    return false;
  }
};
